import { createSelector } from '@ngrx/store';
import { State } from '@state/core.state';
import { projectDetailsPageStateKey } from '../state';

export const selectFeature = (state: State) => state[projectDetailsPageStateKey];

export const loadingProjectCarrierMaps = createSelector(
	selectFeature,
	(state) => state.loadingProjectCarrierMaps
);

export const projectDTO = createSelector(selectFeature, (state) => state.projectDTO);
export const loadingProject = createSelector(selectFeature, (state) => state.loadingProject);
export const updatingProject = createSelector(selectFeature, (state) => state.updatingProject);
export const searchTruckForm = createSelector(selectFeature, (state) => state.searchTruckForm);

export const engagedCarriersList = createSelector(
	selectFeature,
	(state) => state.engagedCarriersList
);
export const engagedCarriersCount = createSelector(
	selectFeature,
	(state) => state.engagedCarriersCount
);

export const procuredCarriersList = createSelector(
	selectFeature,
	(state) => state.procuredCarriersList
);
export const procuredCarriersCount = createSelector(
	selectFeature,
	(state) => state.procuredCarriersCount
);
export const procuredCarriersWithoutGroupCount = createSelector(
	selectFeature,
	(state) => state.procuredCarriersWithoutGroupCount
);

export const removingEngagedCarriersInProgress = createSelector(
	selectFeature,
	(state) => state.removingEngagedCarriersInProgress
);

export const projectGroups = createSelector(selectFeature, (state) => state.projectGroups);

export const loadingAccountCarrierLanes = createSelector(
	selectFeature,
	(state) => state.loadingAccountCarrierLanes
);
export const accountCarrierLanes = createSelector(
	selectFeature,
	(state) => state.accountCarrierLanes
);

export const projectsNextPage = createSelector(selectFeature, (state) => state.projectsNextPage);
export const isLoadingProjectsList = createSelector(
	selectFeature,
	(state) => state.isLoadingProjectsList
);
export const projectsPage = createSelector(selectFeature, (state) => state.projectsPage);
export const projectsPageSize = createSelector(selectFeature, (state) => state.projectsPageSize);
export const totalNumberOfProjects = createSelector(
	selectFeature,
	(state) => state.totalNumberOfProjects
);
export const allProjectsList = createSelector(selectFeature, (state) => state.allProjectsList);

export const usersList = createSelector(selectFeature, (state) => state.usersList);

export const allProjectCarrierMapsList = createSelector(
	selectFeature,
	(state) => state.allProjectCarrierMapsList
);

export const carrierAllocations = createSelector(
	selectFeature,
	(state) => state.carrierAllocations
);

export const carrierAllocationsMap = createSelector(
	selectFeature,
	(state) => state.carrierAllocationsMap
);

export const loadingCarrierAllocations = createSelector(
	selectFeature,
	(state) => state.loadingCarrierAllocations
);

// Filter to carriers with allocations (for Allocations tab)
export const allocatedCarriersList = createSelector(selectFeature, (state) => {
	const allocationsMap = state.carrierAllocationsMap || {};
	return (state.allProjectCarrierMapsList || []).filter(
		(pcm) => allocationsMap[pcm.carrier?.id]
	);
});

// Count of allocated carriers (for Allocations tab badge)
export const allocatedCarriersCount = createSelector(
	allocatedCarriersList,
	(list) => list?.length || 0
);
